(function () {
    "use strict";
    angular.module("atheer.datamodel", []);
})();
